import { TwitterPublicSuggestionResponse } from '~/utils/channels/twitter/types';
import { AutocompleteItem } from '../../autocomplete';

export const user = {
  profile_image_url_https: 'http://fake.link',
  name: 'Buffer',
  screen_name: 'buffer',
};

export const emptyApiResponse = {
  users: [],
  num_results: 0,
  topics: [],
  events: [],
  lists: [],
  ordered_sections: [],
  oneclick: [],
  hashtags: [],
  completed_in: 0.1,
  query: 'null',
} as TwitterPublicSuggestionResponse;

export const validApiResponse = {
  ...emptyApiResponse,
  num_results: 2,
  users: [user],
} as TwitterPublicSuggestionResponse;

export const bufferMentionItem: AutocompleteItem = {
  key: 'Buffer-@buffer',
  text: 'buffer',
  data: {
    avatar: 'http://fake.link',
    handle: '@buffer',
    name: 'Buffer',
    url: 'https://twitter.com/buffer',
  },
};
